var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"footer"}},[_c('footer',[_vm._v("\n    Copyrightⓒ Spade Manager. All Rights Reserved.\n  ")])])
}]

export { render, staticRenderFns }